import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { updateCommentConfig } from "@services/http/members";
import { UpdateCommentByIdOutput } from "@_types/comments";

import { ConfigCommentsStoreActions, ConfigCommentStoreProps } from "./ConfigComments.types";

export const useConfigCommentsStore = create<ConfigCommentStoreProps & ConfigCommentsStoreActions>()(
  devtools((set, get) => ({
    commentConfigs: {
      enableComments: false,
      approveCommentsAutomatically: false,
      studentsCanSeeCommentsOtherTeam: false,
    },
    isConfigsVisible: true,
    isLoading: false,

    setConfigs: data => {
      const { enableComments, approveCommentsAutomatically, studentsCanSeeCommentsOtherTeam } = data;
      set({ commentConfigs: { enableComments, approveCommentsAutomatically, studentsCanSeeCommentsOtherTeam } });
    },

    updateConfigs: async (configStates, courseUuid) => {
      const { commentConfigs } = get();

      const prevCommentConfigs = commentConfigs;
      set({ commentConfigs: configStates });
      try {
        await updateCommentConfig(courseUuid, configStates);
      } catch (error) {
        set({ commentConfigs: prevCommentConfigs });
      }
    },

    handleShowConfigs: () => {
      const { isConfigsVisible } = get();
      set({ isConfigsVisible: !isConfigsVisible });
    },

    setIsLoading: state => set({ isLoading: state }),
  }))
);
